/**
 * `/analytics/*` routes v2 calls (API_ACCESS.md §3.1), held to the snapshot by `api/routes.test.ts`.
 */
import { anySession } from "../../capabilities/access";
import { defineRoutes, route } from "../route";

/** one most-sold row; only `itemId` is read */
export interface FrequentItem {
  itemId: string;
}

export const ANALYTICS = defineRoutes("analytics", {
  itemFrequent: route<{ branchId: string }, FrequentItem[]>("POST", "/analytics/item/frequent", anySession(), {
    notes:
      "the branch's best sellers of the last 30 days, best first; New Order v2's Recommended row (P1 slice 2, both apps). v1 web fetches it at login too (saga/login/fetchCatalog), deleted at New Order's cutover",
  }),
});
